import { TYPE_TO_ICON_MAP } from "@/components/ui/icons";
import { ElementIconType } from "@/components/ui/icons/element-icon-type";
import { FaroMenuItem } from "@faro-lotv/flat-ui";
import { type JSX } from "react";
import {
  ContextMenuAction,
  ContextMenuActionCustomComponentProps,
  ContextMenuActionType,
} from "../../action-types";
import {
  DUPLICATE_SHEET_ACTION,
  DUPLICATE_SHEET_WITH_MARKERS_ACTION,
} from "./duplicate-sheet-action";

/** @returns a "Duplicate" menu item with a submenu for the duplication variants */
function DuplicateSheetMenu({
  elementId,
  onContextMenuItemClicked,
  dark,
}: ContextMenuActionCustomComponentProps): JSX.Element {
  return (
    <FaroMenuItem
      label="Duplicate"
      aria-label="Duplicate"
      Icon={TYPE_TO_ICON_MAP[ElementIconType.CopyIcon]}
      dark={dark}
    >
      {[DUPLICATE_SHEET_ACTION, DUPLICATE_SHEET_WITH_MARKERS_ACTION].map(
        (action) => (
          <FaroMenuItem
            key={action.label}
            label={action.label}
            aria-label={action.label}
            dark={dark}
            onClick={() => onContextMenuItemClicked(elementId, action)}
          />
        ),
      )}
    </FaroMenuItem>
  );
}

export const DUPLICATE_SHEET_MENU_ACTION: ContextMenuAction = {
  type: ContextMenuActionType.duplicate,
  CustomComponent: DuplicateSheetMenu,
};
